import type { ComputedRef } from 'vue'
import type { ContentPackage } from '~/models/Content/ContentPackage'
import { computed } from 'vue'
import { useContentHelper } from '~/composables/useContentHelper'

export default function useCardStyles(colorTheme: ComputedRef) {
  const { isContentHeader } = useContentHelper()

  const style1 = computed(() => ({
    '--card-bg': `${colorTheme.value[5]}`,
    '--card-text': `${colorTheme.value[60]}`,
    '--card-border': `${colorTheme.value.pop}`,
    '--card-accent': `${colorTheme.value[60]}`,
    '--card-hover': `${colorTheme.value[5]}`
  }))

  const style2 = computed(() => ({
    '--card-bg': `${colorTheme.value[5]}`,
    '--card-text': `${colorTheme.value[60]}`,
    '--card-border': `${colorTheme.value[60]}`,
    '--card-accent': `${colorTheme.value[60]}`,
    '--card-hover': `${colorTheme.value[5]}`
  }))

  const themeStyle = computed(() => ({
    '--theme-60': `${colorTheme.value[60]}`,
    '--theme-50': `${colorTheme.value[50]}`,
    '--theme-pop': `${colorTheme.value.pop}`,
    '--theme-20': `${colorTheme.value[20]}`,
    '--theme-10': `${colorTheme.value[10]}`,
    '--theme-5': `${colorTheme.value[5]}`,
    ...style2.value,
  }))

  function cardStyle(content: ContentPackage) {
    if (!isContentHeader(content)) {
      return style2.value
    }

    if (content.viewMode === 'grid') {
      return style1.value
    }

    return style2.value
  }

  return {
    themeStyle,
    cardStyle
  }
}
